import { render, staticRenderFns } from "./yearPicker.vue?vue&type=template&id=7852be16&scoped=true"
import script from "./yearPicker.vue?vue&type=script&lang=js"
export * from "./yearPicker.vue?vue&type=script&lang=js"
import style0 from "./yearPicker.vue?vue&type=style&index=0&id=7852be16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7852be16",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QIcon,QPopupProxy,QDate});
